// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FadH4","right":"styles_right__3igZ2"};